export default {
  GET_LOG: (state, payload) => {
    state.log = payload
  },
  ADD_LOG: (state, payload) => {
    state.log.push(payload)
  }
}